import query from './_query';
import filters from './_filters';
import loadMore from './_load-more';
import api from './_api';
import render from './_render';

export default {
  moduleEl: document.querySelector('.module-references'),
  init() {
    if (!this.moduleEl) return;

    query.init();
    filters.init(this.moduleEl);
    loadMore.init(this.moduleEl);
    api.init(this.moduleEl);
    render.init(this.moduleEl);
  },
};
